import { useEffect } from 'react';

import { Button, Flex, Form, Input, Modal, message } from 'antd';
import { useForm } from 'antd/es/form/Form';
import TextArea from 'antd/es/input/TextArea';

import { useUpdateCollection } from '@/api/monitor_collections';

type TProps = {
	isOpen: boolean;
	setOpen: any;
	data: any;
	setData: any;
};

export default function EditCollectionModal({
	isOpen = false,
	data = null,
	setOpen,
	setData,
}: TProps) {
	const [form] = useForm();

	const { mutate: updateCollection, isLoading } = useUpdateCollection(
		data?.type,
	);

	const handleOk = async () => {
		try {
			await form.validateFields();

			updateCollection(
				{
					type: data?.type,
					id: data?.id,
					title: form.getFieldValue('title'),
					description: form.getFieldValue('description'),
				},
				{
					onSuccess: () => {
						message.success('Updated');
						setOpen(false);
						form.resetFields();
					},
					onError: (error) => {
						const err = error as any;
						message.error(
							`An error occured: ${
								err?.response?.data?.message || err?.message
							}.`,
						);
						console.error('error', error);
					},
				},
			);
		} catch (error) {}
	};

	const handleCancel = () => {
		setOpen(false);
		setData(null);
		form.resetFields();
	};

	useEffect(() => {
		form.setFieldsValue(data);
	}, [form, data]);

	return (
		<Modal
			title={'Edit collection'}
			style={{ maxHeight: 'unset' }}
			centered
			open={isOpen}
			onOk={handleOk}
			onCancel={handleCancel}
			closable
			maskClosable={false}
			footer={[
				<Button key="back" onClick={handleCancel} disabled={isLoading}>
					Cancel
				</Button>,
				<Button
					key="submit"
					type="primary"
					loading={isLoading}
					onClick={handleOk}
					disabled={isLoading}
				>
					Save
				</Button>,
			]}
		>
			<Form
				layout="vertical"
				form={form}
				// initialValues={{
				//   name: data?.name,
				//   description: data?.description,
				// }}
				style={{ marginBottom: '0.5rem' }}
			>
				<Flex vertical>
					<Form.Item
						layout="vertical"
						label="Title"
						name="title"
						rules={[
							{ required: true },
							{
								whitespace: true,
								message: 'Collection title cannot be empty.',
							},
						]}
						initialValue={data?.name}
						// wrapperCol={{ offset: 6, span: 16 }}
						// onMetaChange={}
						// style={{ margin: 0 }}
					>
						<Input />
					</Form.Item>

					<Form.Item
						layout="vertical"
						label="Description"
						name="description"
						initialValue={data?.description}
						// style={{ marginBottom: "3rem" }}
					>
						<TextArea
							rows={2}
							style={{ resize: 'none' }}
							maxLength={255}
							count={{
								show: true,
								max: 255,
							}}
						/>
					</Form.Item>
				</Flex>
			</Form>
		</Modal>
	);
}
